import { ILeaveWebchatDTO } from 'modules/webchat/domain/dtos';
import { IWebchatChatSessionsRepository } from 'modules/webchat/domain/repositories';

/**
 * Sair do chat: a pessoa perde a sala neste navegador, e a próxima conversa
 * dela (ou de quem vier depois) começa do zero. O logout do site e a limpeza
 * da identidade do pré-chat ficam com quem chama.
 */
export default class LeaveWebchatUseCase {
  constructor(private chatSessionsRepository: IWebchatChatSessionsRepository) {}

  public execute({ identifier }: ILeaveWebchatDTO): void {
    this.chatSessionsRepository.forget(identifier);
  }
}
